import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageTitle } from '@/utils/pageTitles';

/**
 * Atualiza o título da aba do navegador conforme a rota atual.
 * Formato: SYSTAGIO - Nome da página
 */
export function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = getPageTitle(pathname);
  }, [pathname]);

  return null;
}
